import { makeStyles } from '@material-ui/core/styles';

const templateStyles = makeStyles(() => ({
	root: {},
	crossIcon: {
		position: 'relative',
		padding: '24px 24px 24px 30px'
	},
	errorContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100vw',
		height: '100vh'
	}
}));

export default templateStyles;
